import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import translationsEN from "./locales/en.json";
import translationsAR from "./locales/ar.json";
import translationsUR from "./locales/ur.json";

const resources = {
    en: {
        translation: translationsEN,
    },
    ar: {
        translation: translationsAR,
    },
    ur: {
        translation: translationsUR,
    },
};

i18n.use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources,
    });

export default i18n;
